import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/initiative_block2.png';
const _withScopeId = n => (_pushScopeId("data-v-7f3b1b6e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = {
  class: "block block1"
};
const _hoisted_3 = {
  class: "main-width main_box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-xl fw-b title_2"
}, "碳手印倡议活动", -1));
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mask"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"block block2\" data-v-7f3b1b6e><div class=\"main-width d-flex ai-center jc-between content_box\" data-v-7f3b1b6e><div data-v-7f3b1b6e><div class=\"fs-xl pb-20 text-blue title\" data-v-7f3b1b6e>关于倡议活动</div><div class=\"fs-m pb-20 pr-80 des\" data-v-7f3b1b6e>采用线上线下联动方式，组织有识之士围绕碳手印文化、知识、标准和产业实践开展讨论交流，举办群体倡议仪式，以激发和带动更多碳手印活动。</div></div><img src=\"" + _imports_0 + "\" width=\"500px\" data-v-7f3b1b6e></div></div>", 1);
const _hoisted_8 = {
  class: "block block3 bg-lightgray"
};
const _hoisted_9 = {
  class: "main-width m_box"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-xl text-blue pb-40"
}, "倡议活动", -1));
const _hoisted_11 = {
  class: "d-flex pl-10 pr-10",
  style: {
    "width": "100%"
  }
};
const _hoisted_12 = {
  class: "card_item d-flex"
};
const _hoisted_13 = {
  class: "item_right pl-20"
};
const _hoisted_14 = {
  class: "title pb-10 fw-b"
};
const _hoisted_15 = {
  class: "position text-blue fs-xs pb-10"
};
const _hoisted_16 = {
  class: "content fs-xs text-gray"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "400px",
    "height": "100px"
  }
}, null, -1));
import { useStore } from 'vuex';
export default {
  __name: 'Initiative',
  setup(__props) {
    const store = useStore();
    const textData = {
      block1: '与我们一起，用实际行动带动更多人参与，共创生态文明新世界！',
      block2: '从教室到会议室，碳手印学院的赋能官们正在引领我们走向更加美好、健康的未来。'
    };
    if (store.state.VUEX_ISMOBILE) textData.block1 = '与我们一起，<br>用实际行动带动更多人参与，<br>共创生态文明新世界！';
    const acList = [{
      title: '第1期碳手印(杭州)倡议活动',
      position: '浙江·杭州',
      content: '',
      src: require('@/assets/initiative_ac1.jpg')
    }, {
      title: '第2期碳手印(北京)倡议活动',
      position: '北京·海淀',
      content: '',
      src: require('@/assets/initiative_ac2.jpg')
    }, {
      title: '第3期碳手印(佛山)倡议活动',
      position: '广东·佛山',
      content: '',
      src: require('@/assets/initiative_ac3.jpg')
    }, {
      title: '第4期碳手印(上海)倡议活动',
      position: '上海·奉贤',
      content: '',
      src: require('@/assets/initiative_ac4.jpg')
    }];
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
        class: "text-white fw-b fs-xl pt-40 text_des",
        innerHTML: textData.block1
      }, null, 8, _hoisted_5)]), _createVNode(_component_el_image, {
        class: "bg-el-img",
        src: require('@/assets/initiative_block1.jpg'),
        fit: "cover"
      }, null, 8, ["src"]), _hoisted_6]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_scrollbar, {
        class: "el_scrollbar"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(acList, (item, idx) => {
          return _createElementVNode("div", {
            class: "news_card",
            key: idx
          }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_image, {
            class: "img",
            fit: "cover",
            src: item.src
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.position), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(item.content), 1)])])]);
        }), 64)), _hoisted_17])]),
        _: 1
      })])])]);
    };
  }
};